import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { CartModel } from '@models/outros/cart.model';
import { ConfirmDialogComponent, ConfirmDialogInterface } from '@components/dialogs/confirm-dialog/confirm-dialog.component';
import { MatriculaGestaoModel } from '@models/gestao/matricula-gestao.model';
import { ProdutoModel } from '@models/financeiro/produto.model';
import { ShoppingCartService } from '@services/outros/shopping-cart.service';
import { TableButtonsEnum, TableColumnTypeEnum, TablePipesTypeEnum } from '@enums/table-custom.enum';
import { TableCustom } from '@models/outros/table-custom.model';
import { Toast } from '@services/outros/toast.service';
@Component({
  selector: 'app-product-table',
  templateUrl: './product-table.component.html',
  styleUrls: ['./product-table.component.scss']
})
export class ProductTableComponent implements OnInit {

  tableData: TableCustom;
  @Input() matricula: MatriculaGestaoModel = new MatriculaGestaoModel();
  @Input() produtos: ProdutoModel[] = new Array<ProdutoModel>();

  constructor(
    private _dialog: MatDialog,
    private _shoppingCartService: ShoppingCartService,
    private _toast: Toast
  ) { }

  ngOnInit(): void {
    this._createTable();
  }

  private _createTable(): void {
    this.tableData = {
      columns: ['descricao', 'valorPadrao', 'market', 'actions'],
      title: 'Lista de Produtos',
      data: [],
      result: {
        noData: 'Não foi encontrado produtos para o candidato.',
        defaultMessage: 'Não existe dados para serem exibidos.'
      },
      columnData: {
        descricao: {
          header: 'PRODUTO',
          type: TableColumnTypeEnum.STRING,
          element: 'descricao'
        },
        valorPadrao: {
          header: 'VALOR',
          type: TableColumnTypeEnum.STRING,
          element: 'valorPadrao',
          pipe: TablePipesTypeEnum.CURRENCY
        },
        market: {
          header: 'MARKET PLACE',
          type: TableColumnTypeEnum.STRING,
          element: 'market',
          pipe: TablePipesTypeEnum.TRUE_FALSE
        },
        actions: {
          header: 'AÇÕES',
          buttonType: TableButtonsEnum.STROKED,
          type: TableColumnTypeEnum.SINGLE_BUTTON,
          buttons: [
            {
              icon: 'add_shopping_cart',
              label: 'ADICIONAR AO CARRINHO',
              onClick: (data) => this._offerProduct(data),
              hashButton: 'COMPONENTS_PRODUCT_TABLE_BTN_OFFER'
            }
          ]
        }
      }
    }
  }

  private _offerProduct(item): void {
    const sale: CartModel = this._shoppingCartService.getCart();
    if (sale.candidato && (sale.candidato.candidatoCpf != this.matricula.candidatoCpf)) {
      this._dialog.open<ConfirmDialogComponent, ConfirmDialogInterface>(ConfirmDialogComponent, {
        data: {
          title: 'Carrinho de Compras',
          subtitle: `Já existe um carrinho de compras aberto para o usuário ${sale.candidato.candidato.nome}.`,
          descriptionFirst: 'Deseja encerrar o carrinho atual e iniciar um novo?'
        }
      })
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            this._setCart(item)
          }
        })
    } else {
      this._setCart(item);
    }
  }

  private _setCart(item) {
    item.quantidade = 1;
    this._shoppingCartService.addProduct(item, this.matricula);
    this._toast.success('Adicionar Produto', `${item.descricao} adicionado ao carrinho de compras!`)
  }
}
